<div class="c-loader-container" cypressTag="General.Loading">
	<div class="c-loader">
		<span></span>
	</div>

	@if (label || data) {
		<p [innerHtml]="label ? label : data"></p>
	}
</div>
